module.exports = __webpack_public_path__ + "static/media/capstone_permissions.79a9c4df.yaml";